import { render, staticRenderFns } from "./SalaryBasedOn.vue?vue&type=template&id=435ef41f"
import script from "./SalaryBasedOn.vue?vue&type=script&lang=js"
export * from "./SalaryBasedOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports